import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { uploadBytes, getStorage, ref, getDownloadURL, getBlob, listAll } from "firebase/storage";
import { storage } from "../../../../utilities/firebase";
import axios from "axios";
import moment from "moment";
import AddDocuments from "../../../blacklist/additional-details";
import Cookies from "js-cookie";
import { signOut } from "firebase/auth";
import { CircleLoader } from "react-spinners";

const DetailRepEdit = (props) => {
    

    const [showDocs, setShowDocs] = useState(false);
    const [IDdownload, setIDdownload] = useState('ID document');
    const [Companydownload, setCompanyRegdownload] = useState('company registration');
    const [Addressdownload, setAddressdownload] = useState('proof of address');
    const [Contractdownload, setContractdownload] = useState('contract/agreement');
    const [item, setMyRep] = useState(null);
    const [change, setChange] = useState(false);
    const [checkCount, setCheckCount] =useState(0);


    const [showCompany, setShowCompany] = useState(true);
    const [showRep, setShowRep] = useState(false);

    const [companyDocuments, setCompanyDocuments] = useState([])
    const [additionalDocuments, setAdditionalDocuments] = useState([])
    const [incidentDocuments, setIncidentDocuments] = useState([])
    const [peopleDocuments, setPeopleDocuments] = useState([])


    const [IDname, setIDname] = useState('');
    const [address, setAddressName] = useState('');
    const [contract, setContractName] = useState('');


    const [incidentDate, setIncidentDate] = useState();
    const [incidentInfo, setIncidentInfo] = useState('')
    const [amountApplied, setAmountApplied] = useState();
    const [amountLost, setAmountLost] = useState();
    const [caseNumber, setCaseNumber] = useState();

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('')
    const [IDnumber, setID] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [type, setType] = useState('');
    const [sex, setSex] = useState('');
    const [title, setTitle] = useState('');
    const [marital, setMarital] = useState('');
    const [IDtype, setIDtype] = useState('');
    const [birthDate, setBirthDate] = useState('');





    const [companyName, setCompanyName] = useState();
    const [companyReg, setCompanyReg] = useState('');

    const [companyType, setCompanyType] = useState();
    const [companyVAT, setCompanyVAT] = useState();
    const [companyAddress, setCompanyAddress] = useState();
    const [companyPhone, setCompanyPhone] = useState();
    const [companyEmail, setCompanyEmail] = useState();

    

    const [blacklist, setBlacklist] = useState([])
    const [representatives, setRepresentatives] = useState([])
    
    const user_id = Cookies.get('token_id')
    

    const {reference} = useParams();

    const person_id = props.person_id; 
    const admin = Cookies.get('token_admin')   

    useEffect(() => {
        
        setTimeout(() => {
            if (item != null) {
            checkAnyChange();
        } 
        }, [1000])
       
    }, [birthDate, firstName, lastName, IDtype, IDnumber, email, phone, type, title, sex, marital])


    useEffect(() => {
        getRepresentatives()
    }, []);

    

    
    useEffect(() => {
        const checkInterval = setInterval(() => {
            if (document.getElementById('change-button') != null) {
                if (change) {
                
                document.getElementById('change-button').disabled = false;
     
            } else {
                document.getElementById('change-button').disabled = true;
    
            }
            }
            setCheckCount(checkCount + 1)
        }, [1000])
 
        //Clearing the interval
        return () => clearInterval(checkInterval);
        
    }, [change, checkCount]);

    function checkAnyChange() {
        var date = new Date(item.date_of_birth);

        var month = ('0' + (date.getMonth() + 1)).slice(-2);
        var day   = ('0' + date.getDate()).slice(-2);
        var year  = date.getFullYear();
        var birth_date = year + '-' + month + '-' + day;

        checkChange(firstName, item.first_name, 'first-name') 
        checkChange(lastName, item.last_name, 'last-name') 
        checkChange(IDtype, item.id_type, 'id-type') 
        checkChange(IDnumber, item.id_number, 'id-number') 
        checkChange(firstName, item.first_name, 'first-name') 
        checkChange(email, item.email, 'email') 
        checkChange(phone, item.phone, 'phone') 
        checkChange(type, item.rep_type, 'rep-type') 
        checkChange(birthDate, birth_date, 'birth-date') 
        checkChange(title, item.title, 'title') 
        checkChange(sex, item.gender, 'gender') 
        checkChange(marital, item.marital, 'marital')
        if (
            checkChange(firstName, item.first_name, 'first-name') ||
            checkChange(lastName, item.last_name, 'last-name') ||
            checkChange(IDtype, item.id_type, 'id-type') ||
            checkChange(IDnumber, item.id_number, 'id-number') ||
            checkChange(firstName, item.first_name, 'first-name') ||
            checkChange(email, item.email, 'email') ||
            checkChange(phone, item.phone, 'phone') ||
            checkChange(type, item.rep_type, 'rep-type') ||
            checkChange(birthDate, birth_date, 'birth-date') ||
            checkChange(title, item.title, 'title') ||
            checkChange(sex, item.gender, 'gender') ||
            checkChange(marital, item.marital, 'marital') 
            
            
        ) {
            setChange(true);
        } else {
            setChange(false)
        }
       
       
    }


    const test_link = "http://localhost:3000/"
    const production_link = "https://apple-tree-server.vercel.app/"



    const getRepresentatives = async () => {
        // axios.defaults.headers.post['Content-Type'] ='application/x-www-form-urlencoded';
        if (admin == 'yes') {
            await axios.get(production_link + "all/representative")
            .then( response => {
                let rep_data = response.data.filter((data) => {
                        return (data.id == person_id)
                    
            })            
            var date = new Date(rep_data[0].date_of_birth);
    
            var month = ('0' + (date.getMonth() + 1)).slice(-2);
            var day   = ('0' + date.getDate()).slice(-2);
            var year  = date.getFullYear();
            
            var htmlDate = year + '-' + month + '-' + day;
            
                
                
                setRepresentatives(rep_data)
                setMyRep(rep_data[0])
                setFirstName(rep_data[0].first_name)
                setLastName(rep_data[0].last_name)
                setID(rep_data[0].id_number)
                setIDtype(rep_data[0].id_type)
                setEmail(rep_data[0].email)
                setPhone(rep_data[0].phone)
                setBirthDate(htmlDate);
                setTitle(rep_data[0].title)
                setSex(rep_data[0].gender)
                setMarital(rep_data[0].marital)
                setType(rep_data[0].rep_type)
    
            })
        } else {
            await axios.post(production_link + "current/representative", {
            user_id
        })
        .then( response => {
            let rep_data = response.data.filter((data) => {
                    return (data.id == person_id)
                
        })            
        var date = new Date(rep_data[0].date_of_birth);

        var month = ('0' + (date.getMonth() + 1)).slice(-2);
        var day   = ('0' + date.getDate()).slice(-2);
        var year  = date.getFullYear();
        
        var htmlDate = year + '-' + month + '-' + day;
        
            
            
            setRepresentatives(rep_data)
            setMyRep(rep_data[0])
            setFirstName(rep_data[0].first_name)
            setLastName(rep_data[0].last_name)
            setID(rep_data[0].id_number)
            setIDtype(rep_data[0].id_type)
            setEmail(rep_data[0].email)
            setPhone(rep_data[0].phone)
            setBirthDate(htmlDate);
            setTitle(rep_data[0].title)
            setSex(rep_data[0].gender)
            setMarital(rep_data[0].marital)
            setType(rep_data[0].rep_type)

        })
        }
        
        
        
    }




    const updateRepresentative = async () => {
        
        
        await axios.post(production_link + 'update/representative', {
            person_id,
            birthDate,
            firstName,
            lastName,
            IDtype,
            IDnumber,
            email,
            phone,
            type,
            title,
            sex,
            marital
        })
        .then((res) => {
            alert('Representative updated successfully!')
            window.location.reload(false)
        })
        .catch((err) => {
            console.warn(err)
        })
    }

    const checkChange = (value, original, id) => {
       
        if (value !== original) {
            document.getElementById(id).classList.add('text-primary')
            return true
        } else {
            document.getElementById(id).classList.remove('text-primary')
            return false
        }
    }

    if (item) {
       return ( 
        <div>

<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">Save changes?</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Save your changes? 
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-success" onClick={() => {
            updateRepresentative();
        }}>Yes</button>
      </div>
    </div>
  </div>
</div>
                        <div class="card text-center">
                            <h4 class="card-header display-6">
                                {item.first_name} {item.last_name}
                            </h4>
                            <div class="card-body  d-flex flex-column jusify-content-center align-items-center">
                                <div className="card p-4 w-75">
                                <p class="">Birth Date: <br /><input type="date" style={{textAlign:"center", color:"lightgrey"}}  onChange={(e) => {
                                        setBirthDate(e.target.value);
                                    }} value={birthDate} className="form-control"  id="birth-date"/></p>
                                    <p class="">First Name: <br /><input style={{textAlign:"center", color:"lightgrey"}}  onChange={(e) => {
                                        setFirstName(e.target.value);
                                    }} value={firstName} className="form-control"  id="first-name"/></p>
                                    <p class="">Last Name: <br /><input id="last-name"  style={{textAlign:"center", color:"lightgrey"}} className="form-control" onChange={(e) => {
                                        setLastName(e.target.value)
                                    }} value={lastName}/></p>
                                    <label for='ID' className="form-label d-block mt-3">Identification: </label>
                                    <div className="d-flex justify-content-center mt-2">
                                        <select style={{textAlign:"center", color:"lightgrey"}} name="id-type" className="form-select w-50 rounded-0 rounded-start" id="id-type" onChange={(e) => {
                                            setIDtype(e.target.value);
                                        }}>
                                            <option value="Green book">Green book</option>
                                            <option selected value="Smart Card">Smart Card</option>
                                            <option value="Passport">Passport</option>
                                            <option value="Driver's License">Driver's License</option>
                                            <option value="Worker's Permit">Worker's Permit</option>
                                            <option value="Temporary ID">Temporary ID</option>
                                        </select>
                                        <input id="id-number"  style={{textAlign:"center", color:"lightgrey"}}  className="form-control rounded-0 rounded-end"  onChange={(e) => {
                                        setID(e.target.value)
                                    }} value={IDnumber}/>
                                    </div>
                                    
                                    <p  class="card-text mt-3">Email: <br /><input id="email"  style={{textAlign:"center", color:"lightgrey"}}  className="form-control"  onChange={(e) => {
                                        // incidentLostChange(e.target.value)
                                        setEmail(e.target.value)
                                    }} value={email}/></p>
                                    <p  class="card-text">Phone: <br /><input id="phone"  style={{textAlign:"center", color:"lightgrey"}}  className="form-control"  onChange={(e) => {
                                        // incidentLostChange(e.target.value)
                                        setPhone(e.target.value)
                                    }} value={phone}/></p>
                                    <select id="rep-type" name="representative-type" class="form-select my-3 text-center" style={{textAlign:"center", color:"lightgrey"}}  onChange={(e) => {
                                        setType(e.target.value)
                                    }} value={type}>
                                        <option selected>Representative type <span className="text-danger">*</span></option>
                                        <option value="Director">Director</option>
                                        <option value="Shareholder">Shareholder</option>
                                        <option value="Employee">Employee</option>
                                        <option value="Surety">Surety</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    <div className="d-flex justify-content-center">
                                        <div>
                                        <label htmlFor="title" className="form-label">Title: </label>
                                        <select style={{textAlign:"center", color:"lightgrey"}} id="title" name="title" class="form-select" onChange={(e) => {
                                            setTitle(e.target.value)
                                        }} value={title}>
                                            <option selected value="Unspecified"></option>
                                            <option value="Mr.">Mr.</option>
                                            <option value="Mrs.">Mrs.</option>
                                            <option value="Ms.">Ms.</option>
                                            <option value="Miss.">Miss.</option>
                                            <option value="Dr.">Dr.</option>
                                            <option value="Adv.">Adv.</option>
                                            <option value="Other">Other</option>
                                        </select>
                                        </div>
                                        <div className="ms-3">
                                            <label htmlFor="sex" className="form-label">Gender: </label>
                                        
                                            <select style={{textAlign:"center", color:"lightgrey"}} name="sex" id="gender" className="form-select" onChange={(e) => {
                                                setSex(e.target.value)
                                            }} value={sex}>
                                                <option selected value="Unspecified"></option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                                <option value="Unknown">Unknown</option>
                                            </select>
                                        </div>

                                    </div>
                                    <div className="d-flex justify-content-center">
                                        <select style={{textAlign:"center", color:"lightgrey"}} name="marital" id="marital" className="form-select w-50 mt-3" onChange={(e) => {
                                        setMarital(e.target.value)
                                    }} value={marital}>
                                        <option selected value="Not selected">Marital Status <span className="text-danger">*</span></option>
                                        <option value="Single">Single</option>
                                        <option value="Married">Married</option>
                                        <option value="Engaged">Engaged</option>
                                        <option value="Divorced">Divorced</option>
                                        <option value="Unknown">Unknown</option>
                                    </select>
                                    </div>
                                    
                                    <hr/>
                                    {/* {
                                            incidentDocuments.length > 0 &&
                                            <div>
                                                <h5 className="display-5 mb-3">Documents</h5>

                                                <p class="card-text" >Contract/Agreement: <br /></p><a className="text-secondary" href={Contractdownload} target="blank_">{contract}</a>

                                            </div>

                                        } */}
                                </div>
                                
                                
                                
                                {/* <button class="btn btn-outline-secondary my-4"  onClick={(e) => {
                                    e.preventDefault();
                                    if (showRep) {
                                        setShowRep(false)
                                    } else {
                                        setShowRep(true)
                                    }
                                }}>Representative Details</button>
                                
                                {
                                    showRep &&
                                    <div className="card p-4 w-75">
                                       {
                                        representatives.map((rep) => {
                                            if (item.company_id === rep.company_id) {
                                                return (
                                                    <div>
                                                        <h5 className="display-5 mb-3 my-3">{rep.first_name} {rep.last_name}</h5>
                                                        <p class="card-text">Title: <br /><span className="text-secondary">{rep.title}</span></p>
                                                        <p class="card-text">ID type: <br /><span className="text-secondary">{rep.id_type}</span></p>
                                                        <p class="card-text">ID number: <br /><span className="text-secondary">{rep.id_number}</span></p>
                                                        <p class="card-text">Date of birth: <br /><span className="text-secondary">{rep.date_of_birth}</span></p>
                                                        <p class="card-text">Gender: <br /><span className="text-secondary">{rep.gender}</span></p>
                                                        <p class="card-text">Marital: <br /><span className="text-secondary">{rep.marital}</span></p>
                                                        <p class="card-text">Phone: <br /><span className="text-secondary">0{rep.phone}</span></p>
                                                        <p class="card-text">Email: <br /><span className="text-secondary">{rep.email}</span></p>
                                                        <hr></hr>
                                                    </div>
                                                )
                                            }
                                        })
                                       }

                                        {
                                            peopleDocuments.length > 0 &&
                                            <div>
                                                <h5 className="display-5 mb-3 my-3">Documents</h5>
                                                
                                                <p class="card-text" >ID document: <br /></p><a className="text-secondary" href={IDdownload} target="blank_">{IDname}</a>

                                            </div>

                                        }

{
                                            peopleDocuments.length > 0 &&
                                            <div>
                                                <p class="card-text" >Proof of address: <br /></p><a className="text-secondary" href={Addressdownload} target="blank_">{address}</a>

                                            </div>

                                        }

                                    </div>
                                } */}
                                
                                {/* <button class="btn btn-outline-secondary my-2" onClick={(e) => {
                                    e.preventDefault();
                                    if (showDocs) {
                                        setShowDocs(false)
                                    } else {
                                        setShowDocs(true)
                                    }
                                }}>Additional Documents</button>
                                {
                                    showDocs && 
                                    <AddDocuments additionalDocuments={additionalDocuments} item={item}/>
                                } */}


                                {/* </div> */}
                                
                            </div>
                            <div class="card-footer text-muted">
                            <button data-bs-toggle="modal" data-bs-target="#exampleModal"  id="change-button" class={`btn btn-primary text-light `} >Change</button>
                            </div>
                        </div>
        </div>
        
    ); 
    } else {
        return (
            <div style={{height:"100vh"}} className="d-flex justify-content-center align-items-center ">
                
                            <CircleLoader size={200} color="#cdc59a"/>
            </div>
        )
    }
    
}
 
export default DetailRepEdit;